
export default function Header() {
    return (
        <h2>Expense Tracker</h2>
    )
}
